import styled from '@emotion/styled';
import { Box, Divider, IconButton, chakra } from '@chakra-ui/react';
import BEIcon from '@molecules/BEIcon';
import Text from '@molecules/Text';
import { usePageNavigation } from '@view/hooks/usePageNavigation';
import { useMemo } from 'react';

interface SessionTitleProps {
  page: string;
  title: string;
}

const StyledHeader = styled.div`
  display: flex;
  gap: 16px;
  justify-content: start;
  align-items: center;
`;

const StyledBackButton = chakra(IconButton, {
  baseStyle: {
    borderWidth: '1px',
    borderRadius: '8px',
    borderColor: 'neutral.500',
    width: '40px',
    height: '40px',
    backgroundColor: 'white',
    margin: '12px 0px',
  },
});

export const SessionTitle = ({ page, title }: SessionTitleProps) => {
  const { goTo, getPreviousPage } = usePageNavigation();

  return (
    <StyledHeader>
      <StyledBackButton
        icon={<BEIcon name="arrow-left" size="sm" />}
        onClick={() => {
          goTo(getPreviousPage(page), page);
        }}
        aria-label={''}
      />
      <Text type="h1">{title}</Text>
    </StyledHeader>
  );
};
